import querystring from 'querystring';
import { api, Auth } from '../../config/configuration/react';
// Get API Concessions
export default async function getConcessionsApi(sourceId = null) {
  const concessionIds = Auth.concessionIds().join(',');
  const userRole = Auth.roleId();
  const userSources = Auth.sourceIds().join(',');
  const userCountry = Auth.country();
  let parameters = `filter={"ids":[${concessionIds}], "enabled":true}&range=[0,999]&sort=["name","ASC"]`;
  if (sourceId?.value) {
    parameters = `filter={"sourceIds":[${sourceId?.value}], "enabled":true}&range=[0,999]&sort=["name","ASC"]`;
  } else if (userRole === 2) {
    parameters = `filter={"sourceIds":[${userSources}],"country": "${userCountry}", "enabled":true}&range=[0,999]&sort=["name","ASC"]`;
  } else if ([3, 5, 6].includes(userRole)) {
    parameters = `filter={"country":"${userCountry}", "enabled":true}&range=[0,50]&sort=["name","ASC"]`;
  }
  const response = await api('getConcessions', null, querystring.parse(parameters));
  return response.data;
}

let currentController = null;
export async function getPaginateConcessionsApi(sourceId = null, pagination = {}) {
  const concessionIds = Auth.concessionIds().join(',');
  const userRole = Auth.roleId();
  const userSources = Auth.sourceIds().join(',');
  const userCountry = Auth.country();
  let parameters = `filter={"ids":[${concessionIds}], "enabled":true,"name":"${pagination.name}"}`;
  if (sourceId?.value) {
    parameters = `filter={"sourceIds":[${sourceId?.value}], "enabled":true,"name":"${pagination.name}"}`;
  } else if (userRole === 2) {
    parameters = `filter={"sourceIds":[${userSources}],"country": "${userCountry}", "enabled":true,"name":"${pagination.name}"}`;
  } else if ([3, 5, 6].includes(userRole)) {
    parameters = `filter={"country":"${userCountry}", "enabled":true,"name":"${pagination.name}"}`;
  }
  parameters = `${parameters}&range=[${pagination?.offset},${pagination?.postsPerPage}]&sort=["name","ASC"]`;
  if (currentController) {
    currentController.abort();
  }

  // Create a new AbortController instance for the new request
  currentController = new AbortController();
  const { signal } = currentController;
  const response = await api('getConcessions', null, querystring.parse(parameters), null, null, 'json', signal);
  currentController = null;
  return {
    list: response.data,
    total: response.headers['content-range'].split('/')[1],
  };
}
